import { Mail, Phone, MapPin, Facebook, Twitter, Youtube } from "lucide-react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom for internal links

const UsefulLinks = [
  {title: "RGPV STUDENT LOGIN", link: "https://www.rgpvdiploma.in/StudentLife/StudentLogin.aspx",},
  {title: "AICTE INTERNSHIP", link: "https://internship.aicte-india.org/",},
  {title: "PARAKH", link: "https://parakh.aicte-india.org/",},
  {title: "ATAL ACADEMY", link: "https://www.aicte-india.org/atal",},
  {title: "TIME TABLE", link: "https://www.rgpvdiploma.in/UploadContent/frm_ViewTT.aspx",},
  {title: "RESULT", link: "https://www.rgpvdiploma.in/Exam/DiplomaIIIYrResult.aspx",},
];
const UsefulLinks2 = [
  {title: "RGPV", link: "https://www.rgpv.ac.in/",},
  {title: "AICTE", link: "https://www.aicte-india.org/",},
  {title: "MP-Online", link: "https://www.mponline.gov.in/portal/",},
  {title: "DTE", link: "https://dte.mponline.gov.in/portal/services/onlinecounselling/counshomepage/home.aspx",}
];

const socialLinks = [
  { name: "Facebook", icon: Facebook, url: "https://facebook.com" },
  { name: "Twitter", icon: Twitter, url: "https://twitter.com" },
  { name: "YouTube", icon: Youtube, url: "https://youtube.com" }
];

export default function Footer() {
  return (
    <footer className="bg-zinc-900 text-zinc-400">
      <div className="container px-4 py-12 mx-auto lg:px-14">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">

          {/* About Us Section */}
          {/* <div className="space-y-4">
            <h2 className="mb-4 text-2xl font-bold text-white">ABOUT US</h2>
            <p className="text-sm leading-relaxed">
              मध्यप्रदेश शासन तकनीकी शिक्षा विभाग डॉ बाबासाहेब आंबेडकर योजना अंतर्गत संचालित शासकीय महिला पॉलिटेक्निक महाविद्यालय सीहोर में अनुसूचित जाति वर्ग की छात्राओं के तीन वर्षीय पाठ्यक्रम कंप्यूटर साइंस एवं इंजीनियरिंग और मॉडर्न ऑफिस मैनेजमेंट में निशुल्क प्रवेश प्रक्रिया एमपी ऑनलाइन के माध्यम से शुरू की जाती है।
            </p>
          </div> */}
          

          {/* useful links Section */}
        

          {/* Social Media Section */}
          <div className="space-y-4">
            <h2 className="mb-4 text-2xl font-bold text-white">DEPARTMENTS </h2>
            <ul className="space-y-2">
              {UsefulLinks.map((link, index) => (
                <li key={index}>
                  <Link to={link.link} target="_blank" rel="noopener noreferrer" className="text-sm leading-relaxed hover:text-white">{link.title}</Link>
            
                </li>
              ))}
            </ul>
          </div>
          <div className="space-y-4">
            <h2 className="mb-4 text-2xl font-bold text-white">IMPORTANT LINKS</h2>
            <ul className="space-y-2">
              {UsefulLinks2.map((link, index) => (
                <li key={index}>
                  <Link to={link.link} target="_blank" rel="noopener noreferrer" className="text-sm leading-relaxed hover:text-white">{link.title}</Link>
            
                </li>
              ))}
            </ul>
          </div>
         
          <div className="space-y-4">
            <h2 className="mb-4 text-2xl font-bold text-white">SOCIAL LINKS</h2>
            <ul className="space-y-2">
              {socialLinks.map((social) => (
                <li key={social.name}>
                  <a 
                    href={social.url} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="flex items-center gap-2 transition-colors duration-200 hover:text-white"
                    aria-label={social.name}
                  >
                    <social.icon className="w-5 h-5" />
                    <span className="text-sm leading-relaxed">{social.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
         
         
         
          {/* Contact Section */}
          <div className="space-y-4">
            <h2 className="mb-4 text-2xl font-bold text-white">CONTACT</h2>
            <ul className="space-y-4">
              <li>
                <a 
                  href="mailto: prinwpoly.seh@mp.gov.in" 
                  className="flex items-center gap-2 transition-colors duration-200 hover:text-white"
                  aria-label="Email"
                >
                  <Mail className="w-5 h-5" />
                  <span className="text-sm leading-relaxed">prinwpoly.seh@mp.gov.in</span>
                </a>
              </li>
              <li>
                <a 
                  href="tel:07562-292337" 
                  className="flex items-center gap-2 transition-colors duration-200 hover:text-white"
                  aria-label="Phone"
                >
                  <Phone className="w-5 h-5" />
                  <span className="text-sm leading-relaxed">07562-292337</span>
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="flex-shrink-0 w-5 h-5" />
                <span className="text-sm leading-relaxed">Goverment Women's Polytechnic College, Sehore, Madhya Pradesh</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="border-t border-zinc-800">
        <div className="container px-4 py-4 mx-auto">
          <p className="text-sm text-center">© 2025 Goverment Women's Polytechnic College, Sehore, Madhya Pradesh</p>
        </div>
      </div>
    </footer>
  );
}
